import API from "@/api/modules/clinic-content-moderation";

const state = () => ({
  clinicSandboxText: [],
});

export default {
  namespaced: true,
  state,
  mutations: {
    SET_DATA(state, { type, data }) {
      state[type] = data;
    },
  },
  actions: {
    getClinicSandboxText({ commit }) {
      return API.getClinicSandboxText().then((response) => {
        if (response && response.data) {
          const list = Array.isArray(response.data) ? response.data : response.data.texts || [];
          commit("SET_DATA", { type: "clinicSandboxText", data: list });
        }
      });
    },
    updateSandboxClinicText(_, payload) {
      return API.updateSandboxClinicText(payload);
    },
    setTextSandboxApproveStatus(_, payload) {
      return API.setTextSandboxApproveStatus(payload);
    },
    setTextSandboxDisapproveStatus(_, payload) {
      return API.setTextSandboxDisapproveStatus(payload);
    },
  },
};
